import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as quotationActions from '../Actions/quotationActions';
import QuotationForm from "../Components/Quotations/QuotationForm";
import { quotationService } from "../Services/QuotationService.js";


class QuotationContainer extends Component {
	constructor() {
		super();
		this.acceptQuotation = this.acceptQuotation.bind(this);
	}
	
	acceptQuotation(){
//		console.log(this.props.quotationRecord);
		if(this.props.quotationRecord.orders[0].state=="quotation_pending"){
			quotationService.acceptQuotation(this.props.quotationRecord.id, true, this.props.user.access_token)
						.catch(err => {/*console.log(err);*/});
			this.props.history.push('/quotationList');
		}
	}

	render() {
		return (<QuotationForm
					quotationId = {this.props.quotationRecord.quotation}
					code = {this.props.quotationRecord.code}
					state = {this.props.quotationRecord.orders[0].state}
					accessToken = {this.props.user.access_token}
					acceptQuotation = {this.acceptQuotation}/>);
	}
}

function mapStateToProps(state, ownProps) {  
	return {quotationRecord: state.quotations[ownProps.match.params.id], user: state.user}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(quotationActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotationContainer);  